export default '<p>Dear {{firstName}} {{lastName}}</p>' +
    '<p>{{sender}} has invited you to join {{entity}} as {{role}}</p>' +
    '<p>The link below allows access to the platform. If you don\'t already have an account you\'ll be prompted to create a password, after which you can log in with your e-mail address and newly created password.</p>' +
    '<p style="text-align: center;"><a href="{{link}}" style="color: {{color}}; font-weight: bold;">Access {{entity}}</a></p>' +
    '<p>Best wishes</p>' +
    '<p>The Zarucchi Team</p>'